import { Link } from "react-router";
import { GO_PATH } from "@/features/go/router";

export const LoginFirstVisit = () => (
  <p className="text-sm text-gray-500 dark:text-gray-400">
    <span className="font-semibold text-gray-900 dark:text-white">Première visite ?</span>
    {" "}
    Utilisez l'invitation reçue de votre CSE ou
    {" "}
    <Link to={GO_PATH} className="text-primary hover:underline" data-testid="login-first-visit-link">
      cliquez ici
    </Link>
    .
  </p>
);

LoginFirstVisit.displayName = "LoginFirstVisit";
